module.exports = __webpack_public_path__ + "img/tuijianjigou6.16fe8c33.png";